export default __webpack_public_path__ + "static/1-3a33a8380b26d603286fbf2fc28790c0.png";